import { ReactElement } from 'react';
import DOMPurify from 'dompurify';
import MaterialClickHandler from '../../../../../../common/material-click-handler/material-click-handler';
import MaterialLink from '../../../../../../common/material-link/material-link';
import handleLinkClick from '../../utils/handle-link-click';
import './material-title.scss';

type MaterialTitleProps = { item: Material; index: number; internalPath?: string };

const MaterialTitle = (props: MaterialTitleProps): ReactElement => {
    const { item, index, internalPath } = props;

    const sanitizedTitle = DOMPurify.sanitize(item.title);

    const onClick = (): void => handleLinkClick({ item, index });

    return (
        <MaterialClickHandler item={item} materialProps={{ itemIndex: index, internalPath }}>
            <h3 className='material-title-wrapper'>
                <MaterialLink
                    className='material-title'
                    dangerouslySetInnerHTML={{ __html: sanitizedTitle }}
                    item={item}
                    internalPath={internalPath}
                    title={item.title}
                    onClick={onClick}
                />
            </h3>
        </MaterialClickHandler>
    );
};

export default MaterialTitle;
